import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import "./DesignSwitcher.scss";

function DesignSwitcher({
  alignRight = false,
  marginLeft,
  marginRight,
  onClick,
  infoOnClick,
  buttonText,
  buttonBgColor,
  buttonBorderColor,
  pipeColor,
  minWidth,
}) {
  const buttonStyle = { background: buttonBgColor, borderColor: buttonBorderColor, marginLeft, marginRight, minWidth };
  const pipeStyle = { background: pipeColor };

  return (
    <>
      {alignRight && <div className="flex-grow-1" />}
      <Button onClick={onClick} className="button" style={buttonStyle}>
        <FontAwesomeIcon icon={faCircleInfo} onClick={infoOnClick} className="icon" />
        <div className="pipe" style={pipeStyle} />
        {buttonText}
      </Button>
    </>
  );
}

export default DesignSwitcher;
